import { LitElement, html, css } from "lit";


export class KeywordsLoop extends LitElement {
    static properties = {
        keywords: { type: String },
        interval: {},
        counter: { type: Number },
        duration: { type: Number }
    }

    static styles = css`
        :host{
            --color : grey;
        }

        .word{
            display : block;
        }
        .wrapper{
            display: block;
            padding: 10px 10px 10px 21px;
            margin: 20px 0;
            font-weight: bold;
            font-size: 22px;
            color: var(--noir);
            border-left: 2px solid var(--noir, grey);
            overflow : hidden;
        }
        `;


    constructor() {
        super();
        this.counter = 0;
        this.duration = 3000
    }

    get spanword() {
        return this.renderRoot?.querySelector('.word') ?? null;
    }

    incrementCounter() {
        if (this.counter < this.words.length - 1) {
            this.counter += 1;
        }
        else {
            this.counter = 0;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        clearInterval(this.interval)
    }

    updated(changed) {
        if (changed.has('counter')) {

            const fadeIn = this.spanword.animate(
                [{ opacity: 0, transform: 'translateX(30px)' }, { opacity: 1, transform: "translateX(0)" }],
                { duration: 750, easing: 'ease', delay: 0 });

            fadeIn.onfinish = () => {
                const pause = this.spanword.animate({}, { duration: this.duration })
                pause.onfinish = () => {
                    const fadeout = this.spanword.animate(
                        [{ opacity: 1, transform: 'translateX(0px)' },
                        { opacity: 0, transform: "translateX(30px)" }],
                        { duration: 750, easing: 'ease' });
                    fadeout.onfinish = () => {
                        this.incrementCounter()
                    }
                }

            }
        }
    }

    get displayWords() {
        this.words = []
        this.words = this.keywords.split(',')
        return html`${this.words[this.counter]}`;
    }

    render() {
        return html`
    <div class="wrapper">
        <span class="word">${this.displayWords} </span>
    </div>`
    }
}


customElements.define('keywords-loop', KeywordsLoop);


